import React from "react";

const Devider: React.FC = () => {
  return (
    <div className="divider"></div>
  );
};
export default Devider;
